export default __webpack_public_path__ + "static/media/home.29a6e854.svg";